import { getCurrentProfileSelect } from '../../selectors/get-current'
import { getValueReduxUtil } from '../../../../redux/utils'
import { PROFILE_KEY } from '../../../../../models'
import { UNIT } from '../../../../../constant'
import { getFeetHeightUtil, getMetersHeightUtil } from '../../../../height/utils'
import { PROFILES_ACTION } from '../../constants'
import { updateProfileAction } from '../update'

export function updateHeightUnitProfileAction (value) {
  return (dispatch, getState) => {
    const profile = getCurrentProfileSelect(getState())
    const heightUnit = getValueReduxUtil(profile, PROFILE_KEY.HEIGHT_UNIT)
    if (heightUnit === value) {
      return
    }
    const height = getValueReduxUtil(profile, PROFILE_KEY.HEIGHT)
    const updates = {
      [PROFILE_KEY.HEIGHT_UNIT]: value
    }
    if (height != null && value === UNIT.METRIC) {
      updates[PROFILE_KEY.HEIGHT] = (
        getMetersHeightUtil(height)
      )
    } else if (height != null) {
      updates[PROFILE_KEY.HEIGHT] = (
        getFeetHeightUtil(height)
      )
    }
    dispatch(updateProfileAction({
      type: PROFILES_ACTION.UPDATE_HEIGHT_UNIT,
      payload: {
        updates
      }
    }))
  }
}
